// @flow
import {
  ADMIN_UPDATE_PROJECT_LIST,
  ADMIN_SET_RESELLER_TREE,
  ADMIN_DELETE_PROJECT_LIST,
  ADMIN_PROJECT_ENDUSER_LIST,
  ADMIN_GET_PROJECT_LIST
} from "../../global/actions/actionNames";

const initialState = {
  projects: null,
  resellerTree: null,
  endusers: null
};

const projectReducers = (state: * = initialState, actions: *): * => {
  switch (actions.type) {
    case ADMIN_GET_PROJECT_LIST:
      if (actions.projects !== null) {
        return {
          ...state,
          projects: [...actions.projects]
        };
      }
      return state;

    case ADMIN_UPDATE_PROJECT_LIST:
      if (actions.project !== null && actions.project.id !== null) {
        let projects = state.projects === null ? [] : [...state.projects];
        if (projects.length > 0) {
          let index = projects.findIndex(x => x.id === actions.project.id);
          if (index > -1) {
            projects[index] = actions.project;
          } else {
            projects.push(actions.project);
          }
        } else {
          projects.push(actions.project);
        }

        return {
          ...state,
          projects: projects
        };
      }
      return state;

    case ADMIN_SET_RESELLER_TREE:
      if (actions.resellers !== null) {
        return {
          ...state,
          resellerTree: [...actions.resellers]
        };
      }
      return state;

    case ADMIN_DELETE_PROJECT_LIST:
      if (actions.projectId !== null && state.projects !== null) {
        let projects = [...state.projects];
        if (projects.length > 0) {
          let index = projects.findIndex(x => x.id === actions.projectId);
          if (index > -1) {
            projects.splice(index, 1);
            return {
              ...state,
              projects: projects
            };
          }
        }
      }
      return state;

    case ADMIN_PROJECT_ENDUSER_LIST:
      if (actions.endusers !== null) {
        const endusers = [...actions.endusers];
        return {
          ...state,
          endusers: endusers
        };
      }
      return state;

    default:
      return state;
  }
};
export default projectReducers;
